// Port of api/fuel/app/classes/controller/api/monty/session/subdomains.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Group from 'offline/model/group'
import User from 'offline/model/user'
import PlatformSubdomain from 'offline/model/platform/subdomain'

function sessionUserId(params) {
	return params.sessionUserId || DB.meta('sync_user_id') || false
}

function now() {
	return Math.floor(Date.now() / 1000)
}

function subdomainData(item) {
	if (!item) return false

	var user = User.with_id(item.get_user_id())
	var date = parseInt(item.get_date(), 10) || 0

	return {
		id: parseInt(item.get_id(), 10) || 0,
		value: item.get_value(),
		ready: parseInt(item.get_status(), 10) || 0,
		status: parseInt(item.get_status(), 10) || 0,
		date: date,
		user: user ? user.get_name() : '',
		recipient: parseInt(item.get_recipient(), 10) || 0,
		canCancel: !item.get_status(),
		canRemove: !!(item.get_status() && (Date.now() / 1000) >= (date + Constants.TIME_WEEK)),
		removeDate: date + Constants.TIME_WEEK
	}
}

function groupPayload(group, request) {
	if (!group) return false
	var data = group.to_array()
	data.subdomain = request ? request.value : false
	return data
}

export default function(params) {
	var method = params.__offlineMethod || 'GET'
	var userId = sessionUserId(params)
	var sessionUser = userId ? User.with_id(userId) : false

	if (!userId) {
		return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
	}

	if (method !== 'GET') {
		if (!sessionUser) {
			return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
		}

		if (method === 'POST') {
			var type = params.type || false
			var value = String(params.value || '').trim().toLowerCase()
			var selectedGroup = false

			if (!value) {
				return Promise.reject({ error: 'Invalid subdomain request.', offline: true })
			}

			if (type === 'user') {
				var userSubdomain = PlatformSubdomain.record({
					where: [
						['user_id', '=', userId],
						['subdomain_recipient', '=', userId],
						['subdomain_type', '=', Constants.TYPE_USER]
					]
				})

				if (userSubdomain && userSubdomain.get_status() && userSubdomain.get_date() > (now() - Constants.TIME_WEEK)) {
					return Promise.reject({ error: 'Subdomain cannot be changed yet.', offline: true })
				}

				if (userSubdomain && !userSubdomain.get_status()) {
					DB.run('UPDATE platform_subdomain SET subdomain_value = ? WHERE subdomain_id = ?', [value, userSubdomain.get_id()])
				} else {
					DB.run('INSERT INTO platform_subdomain (user_id, subdomain_date, subdomain_status, subdomain_type, subdomain_recipient, subdomain_value) VALUES (?, ?, ?, ?, ?, ?)', [
						userId, now(), 0, Constants.TYPE_USER, userId, value
					])
				}

				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: { group: false }
					}
				})
			}

			if (type === 'group') {
				var groupId = parseInt(params.group, 10) || 0
				var userGroupSubdomain = PlatformSubdomain.record({
					where: [
						['user_id', '=', userId],
						['subdomain_type', '=', Constants.TYPE_GROUP]
					]
				})

				selectedGroup = Group.with_id(groupId)

				if (!selectedGroup || parseInt(selectedGroup.get_user_id(), 10) !== userId) {
					return Promise.reject({ error: 'Invalid group request.', offline: true })
				}

				if (userGroupSubdomain && parseInt(userGroupSubdomain.get_recipient(), 10) !== groupId) {
					return Promise.reject({ error: 'Group subdomain already assigned elsewhere.', offline: true })
				}

				if (userGroupSubdomain && userGroupSubdomain.get_status() && userGroupSubdomain.get_date() > (now() - Constants.TIME_WEEK)) {
					return Promise.reject({ error: 'Subdomain cannot be changed yet.', offline: true })
				}

				if (!userGroupSubdomain) {
					var reservedGroup = PlatformSubdomain.record({
						where: [
							['user_id', '<>', userId],
							['subdomain_type', '=', Constants.TYPE_GROUP],
							['subdomain_recipient', '=', groupId]
						]
					})
					if (reservedGroup) {
						return Promise.reject({ error: 'Group subdomain already requested.', offline: true })
					}
				}

				var usedSubdomain = PlatformSubdomain.record({
					where: [
						['subdomain_id', '<>', userGroupSubdomain ? userGroupSubdomain.get_id() : 0],
						['subdomain_value', '=', value]
					]
				})

				if (usedSubdomain) {
					return Promise.reject({ error: 'Subdomain already taken.', offline: true })
				}

				if (userGroupSubdomain && !userGroupSubdomain.get_status()) {
					DB.run('UPDATE platform_subdomain SET subdomain_value = ? WHERE subdomain_id = ?', [value, userGroupSubdomain.get_id()])
				} else {
					DB.run('INSERT INTO platform_subdomain (user_id, subdomain_date, subdomain_status, subdomain_type, subdomain_recipient, subdomain_value) VALUES (?, ?, ?, ?, ?, ?)', [
						userId, now(), 0, Constants.TYPE_GROUP, groupId, value
					])
				}

				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: {
							group: groupPayload(selectedGroup, { value: value })
						}
					}
				})
			}

			return Promise.reject({ error: 'Invalid subdomain request.', offline: true })
		}

		if (method === 'DELETE') {
			var deleteType = params.type || false

			if (deleteType === 'user') {
				DB.run('DELETE FROM platform_subdomain WHERE user_id = ? AND subdomain_recipient = ? AND subdomain_type = ?', [
					userId, userId, Constants.TYPE_USER
				])
				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: { group: false }
					}
				})
			}

			if (deleteType === 'group') {
				var existing = PlatformSubdomain.record({
					where: [
						['user_id', '=', userId],
						['subdomain_type', '=', Constants.TYPE_GROUP]
					]
				})
				var existingGroup = existing ? Group.with_id(existing.get_recipient()) : false

				DB.run('DELETE FROM platform_subdomain WHERE user_id = ? AND subdomain_type = ?', [
					userId, Constants.TYPE_GROUP
				])

				return DB.save().then(function() {
					return {
						session: { offline: true },
						data: {
							group: groupPayload(existingGroup, false)
						}
					}
				})
			}

			return Promise.reject({ error: 'Invalid subdomain request.', offline: true })
		}

		return Promise.reject({ error: 'This action is not available offline.', offline: true })
	}

	var user = PlatformSubdomain.record({
		where: [
			['user_id', '=', userId],
			['subdomain_type', '=', Constants.TYPE_USER]
		]
	})

	var group = PlatformSubdomain.record({
		where: [
			['user_id', '=', userId],
			['subdomain_type', '=', Constants.TYPE_GROUP]
		]
	})

	return Promise.resolve({
		session: { offline: true },
		data: {
			user: subdomainData(user),
			group: subdomainData(group),
			canGroup: sessionUser.get_upgrade() === Constants.USER_UPGRADE_GROUP
		}
	})
}
